module.exports = new __parcel__URL__("bantilope.a0cf1a4b.jpg").toString();